import * as actions$3 from './CCC/actions.js';
export { actions$3 as CCCActions };
import * as actions$2 from './data-layer/actions.js';
export { actions$2 as DataLayerActions };
import * as actions$4 from './Prescriptions/state/actions.js';
export { actions$4 as PrescriptionsActions };
import * as actions$1 from './Profile/actions.js';
export { actions$1 as ProfileActions };
import * as actions$5 from './Unlink/actions.js';
export { actions$5 as UnlinkActions };

const CHANGE_FORM_VALUE = 'my-account/change-form-value';
const CREATE_ORDER = 'my-account/create-order';
const CREATE_ORDER_SUCCESS = 'my-account/create-order-success';
const CREATE_ORDER_FAILED = 'my-account/create-order-failed';
const changeFormValue = (payload)=>({
        type: CHANGE_FORM_VALUE,
        payload
    })
;
const createOrder = (payload)=>({
        type: CREATE_ORDER,
        payload
    })
;
const createOrderSuccess = (payload)=>({
        type: CREATE_ORDER_SUCCESS,
        payload
    })
;
const createOrderFailed = (error)=>({
        type: CREATE_ORDER_FAILED,
        error
    })
;

export { CHANGE_FORM_VALUE, CREATE_ORDER, CREATE_ORDER_FAILED, CREATE_ORDER_SUCCESS, changeFormValue, createOrder, createOrderFailed, createOrderSuccess };
//# sourceMappingURL=actions.js.map
